import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Link,
  FormControlLabel,
  Switch,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../languages";
import { useSettings } from "../context/SettingsContext";

interface SettingsPopupProps {
  open: boolean;
  onClose: () => void;
}

export default function SettingsPopup({ open, onClose }: SettingsPopupProps) {
  const { settings, updateSettings } = useSettings();
  const { t, i18n } = useTranslation();

  return (
    <Dialog id="settings-dialog" open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t("settings.title")}</DialogTitle>
      <DialogContent dividers>
        <FormControl id="settings-language" fullWidth margin="normal">
          <InputLabel id="language-select-label">{t("settings.language")}</InputLabel>
          <Select
            labelId="language-select-label"
            label="Language"
            value={settings.language}
            onChange={(e) => {
              updateSettings({ language: e.target.value });
              i18n.changeLanguage(e.target.value);
            }}
          >
            {SUPPORTED_LANGUAGES.map((option) => (
              <MenuItem key={option.code} value={option.code}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box id="settings-streamer-mode" sx={{ mt: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={settings.streamerMode}
                onChange={(e) => updateSettings({ streamerMode: e.target.checked })}
              />
            }
            label={t("settings.streamerMode")}
          />
          <Typography variant="caption" color="text.secondary" sx={{ display: "block", ml: 6 }}>
            {t("settings.streamerModeDesc")}
          </Typography>
        </Box>

        <Box id="settings-links" sx={{ display: "flex", gap: 2, mt: 2 }}>
          <Link href="/privacy-policy" underline="hover">
            {t("footer.privacyPolicy")}
          </Link>
          <Link href="/cookie-policy" underline="hover">
            {t("footer.cookiePolicy")}
          </Link>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("settings.close")}</Button>
      </DialogActions>
    </Dialog>
  );
}
